import {gql} from "@apollo/client";
import {GET_USER_FIELDS} from "./GetUser";

export const GET_PAYMENT_STATUS = gql`
          ${GET_USER_FIELDS}
          query GetPaymentStatusQuery($paymentId: String!){
    paymentStatus (
            paymentId: $paymentId
    )
    {
        paymentInformation {
            status
            type
            amount
            method {
                    name
            }
            timestamp
            creditTxTimestamp
        }
        user {
            ...GetUserFields
        }
        
    }
}`;